import axios from "axios";

const COMMON_URL = `${process.env.REACT_APP_API_URL}`;
const SPRING_URL = `${process.env.REACT_APP_SPRING_API_URL}`;
const GETALLSTAFF = "core/api/v1/accesscontrol/getUsersForHKAssign/";
const OOOREPORTFORSELECTEDDATE =
  "core/api/v1/hk/get-ooo-report-for-selected-date";

export const getAllStaffsData = async () => {
  return axios
    .get(SPRING_URL + GETALLSTAFF)
    .then((resp) => resp.data)
    .catch((err) => {
      throw new Error(err);
    });
};

export const getOOOReportForSelectedDate = async (
  fromDate,
  endDate,
  checked
) => {
  return axios
    .get(
      SPRING_URL +
        OOOREPORTFORSELECTEDDATE +
        "?fromDate=" +
        fromDate +
        "&endDate=" +
        endDate +
        "&isUpdate=" +
        checked
    )
    .then((resp) => resp.data)
    .catch((err) => {
      throw new Error(err);
    });
};
